var _window$GLOBAL_INFO;
export function getGlobalConfig() {
  return window.GLOBAL_INFO || {};
}
export const clientUrl = window.GLOBAL_INFO.wujiClientUrl || '/';
export const HAS_CLS_LOGGER = !!((_window$GLOBAL_INFO = window.GLOBAL_INFO) !== null && _window$GLOBAL_INFO !== void 0 && (_window$GLOBAL_INFO = _window$GLOBAL_INFO.deploySettingFlag) !== null && _window$GLOBAL_INFO !== void 0 && _window$GLOBAL_INFO.hasDsClsLogger);
//# sourceMappingURL=config.js.map
